import actionNames from "action-names";

export const LOAD_THEME = "LOAD_THEME",
    RESET_THEME = "RESET_THEME",
    UPDATE_THEME = "UPDATE_THEME",
    UPLOAD_FONT = "UPLOAD_FONT",
    fontsActions = actionNames("fonts");
